import { ref, type Ref } from 'vue'
import { useRouter } from 'vue-router'

import { AuthSetPlanFlow, type SetPlanOutcome } from '../flows/AuthSetPlanFlow'

import { resetPlanSelection } from '@/features/credits'

export interface UseSetPlan {
  pending: Readonly<Ref<boolean>>
  run: () => Promise<void>
}

export function useSetPlan(): UseSetPlan {
  const router = useRouter()
  const flow = new AuthSetPlanFlow()
  const pending = ref(false)
  let inFlight: Promise<void> | null = null

  async function navigate(): Promise<void> {
    const outcome: SetPlanOutcome = flow.execute()
    try {
      await router.push({ name: outcome.next === 'signup' ? 'Signup' : 'Summary' })
    } catch (error) {
      if (outcome.next === 'summary') resetPlanSelection()
      throw error
    }
  }

  function run(): Promise<void> {
    if (inFlight) return inFlight
    pending.value = true
    const task = navigate().finally(() => {
      pending.value = false
      if (inFlight === task) inFlight = null
    })
    inFlight = task
    return task
  }

  return { pending, run }
}
